import React, { useState, useRef } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  CardHeader,
  Table,
  Button,
  Badge,
} from "reactstrap";
import logo from '../../assets/images/logos/logo_preta.jpeg'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'; // Importação específica para autoTable
import * as moment from "moment";

const EstandeDetail = ({ estande, tags }) => {
  const componentRef = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const handleExportPDF = async () => {
    try {
      setIsLoading(true);
      const doc = new jsPDF({
        unit: 'mm',
        format: 'a4',
        compress: true // Ativa compressão para reduzir tamanho do arquivo
      });

      // Configurações de layout
      const margin = 10; // Reduzi a margem para ganhar espaço
      const pageWidth = doc.internal.pageSize.getWidth();
      const availableWidth = pageWidth - (2 * margin);
      
      // Cores corporativas (ajuste conforme seu branding)
      const primaryColor = [54, 54, 54 ];
      const secondaryColor = [79, 79, 79];

      // Estilos tipográficos
      const setHeaderStyle = () => {
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(...primaryColor);
      };

      const setBodyStyle = () => {
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(...secondaryColor);
      };

      // --- CABEÇALHO ---
      setHeaderStyle();
      doc.setFontSize(14);
      doc.text(`RELATÓRIO DO ESPAÇO - ${estande.nome.toUpperCase()}`, pageWidth / 2, 15, { align: 'center' });
      
      // Linha divisória
      doc.setDrawColor(...primaryColor);
      doc.setLineWidth(0.5);
      doc.line(margin, 20, pageWidth - margin, 20);

      // --- INFORMAÇÕES BÁSICAS ---
      let yPosition = 25; // Posição inicial após cabeçalho

      setHeaderStyle();
      doc.setFontSize(12);
      doc.text('INFORMAÇÕES BÁSICAS', margin, yPosition);
      yPosition += 5;

      setBodyStyle();
      doc.setFontSize(10);
      
      // Função compacta para adicionar texto
      const addCompactText = (label, value, y) => {
        doc.setFont('helvetica', 'bold');
        doc.text(`${label}:`, margin, y);
        doc.setFont('helvetica', 'normal');
        doc.text(value, margin + 25, y);
        return y + 4; // Reduzi o espaçamento entre linhas
      };

      yPosition = addCompactText('Nome', estande.nome, yPosition);
      yPosition = addCompactText('Área', `${estande.area} m²`, yPosition);
      
      if (!estande.alterou_area) {
          yPosition = addCompactText('Dimensões', `${estande.largura}m x ${estande.comprimento}m`, yPosition);
      }
      
      if (estande.altura_minima) {
        yPosition = addCompactText('Altura mínima', ` ${estande.altura_minima}m`, yPosition);
      }

      if (estande.altura_maxima) {
        yPosition = addCompactText('Altura máxima', ` ${estande.altura_maxima}m`, yPosition);
      }

      if (estande.pavilhao != null) {
        yPosition = addCompactText('Pavilhão', ` ${estande.pavilhao.nome}`, yPosition);
      }

      if (estande.metragem_bonificada > 0) {
        yPosition = addCompactText('M² bonificada', ` ${estande.metragem_bonificada}`, yPosition);
      }
      
      if (estande.observacao) {
        yPosition += 2; // Espaço extra antes da observação
        doc.text(`Observação: ${estande.observacao}`, margin, yPosition, {
          maxWidth: availableWidth
        });
        yPosition += 8; // Espaço maior para texto multilinha
      }

      // --- ITENS INCLUSOS ---
      yPosition += 3; // Pequeno espaço antes da nova seção
      
      setHeaderStyle();
      doc.text('ITENS INCLUSOS', margin, yPosition);
      yPosition += 5;

      setBodyStyle();
      // if (estande.tags?.length > 0) {
      //   // Layout em colunas para itens inclusos (3 colunas)
      //   const tagsPerColumn = Math.ceil(estande.tags.length / 3);
      //   const columnWidth = availableWidth / 3;
        
      //   for (let col = 0; col < 3; col++) {
      //     const startIdx = col * tagsPerColumn;
      //     const endIdx = startIdx + tagsPerColumn;
      //     const columnTags = estande.tags.slice(startIdx, endIdx);
          
      //     if (columnTags.length > 0) {
      //       let tempY = yPosition;
      //       columnTags.forEach(tag => {
      //         doc.text(`• ${tag.nome}`, margin + (col * columnWidth), tempY);
      //         tempY += 4;
      //       });
      //       yPosition = Math.max(yPosition, tempY);
      //     }
      //   }
      //   yPosition += 3;
      // } else {
      //   doc.text('Nenhum item adicional incluído', margin, yPosition);
      //   yPosition += 5;
      // }

      // --- DETALHES FINANCEIROS ---
      setHeaderStyle();
      doc.text('DETALHES FINANCEIROS', margin, yPosition);
      yPosition += 5;

      // Mapeamento das Tags/Adicionais seguindo a lógica da renderização
      const tagsRows = (estande.tags || []).map((tagEstande) => {
        const isManual = tagEstande.manual;
        const unitario = isManual 
          ? tagEstande.valor_salvo 
          : (tags?.find(t => t.tag_id === tagEstande.id)?.valor || 0);
        
        const cobraPorMetro = tagEstande.tag && tagEstande.tag[0]?.cobra_por_metro;
        const qtd = isManual && tagEstande.quantidade_salva > 0 ? tagEstande.quantidade_salva : 
        cobraPorMetro ? `${estande.area} m²` : '1';
                              
        const total = isManual 
          ? 
          (tagEstande.quantidade_salva > 0 ? tagEstande.valor_salvo * tagEstande.quantidade_salva : 
          (tagEstande.valor_salvo * (tagEstande.tag[0].cobra_por_metro ? estande.area : 1))) : 
          (unitario * (cobraPorMetro ? estande.area : 1));

        return [
          { content: `${tagEstande.nome}${isManual ? ' (Manual)' : ''}`, styles: { fontStyle: 'normal' } },
          formatCurrency(unitario),
          qtd,
          { content: formatCurrency(total), styles: { fontStyle: 'bold' } }
        ];
      });

      // Lógica para KVA (Manual vs Automático)
      
      const kvaRow = (estande?.kva != null || estande?.kva_manual) ? [
        { content: `KVA${estande.kva_manual ? ' (Manual)' : ''}` },
        estande.kva_manual 
          ? formatCurrency(estande.kva_valor_salvo / (estande.kva_quantidade_salva || 1))
          : formatCurrency(estande.kva?.valor / (estande.kva?.quantidade || 1)),
        estande.kva_manual 
          ? (estande.kva_quantidade_salva || 1)
          : (estande.kva?.cobra_por_metro ? `${estande.area} m²` : estande.kva?.quantidade),
        { 
          content: estande.kva_manual 
            ? formatCurrency(estande.kva_valor_salvo)
            : formatCurrency(estande.kva?.cobra_por_metro ? (estande.kva?.valor * estande.area) : estande.kva?.valor),
          styles: { fontStyle: 'bold' } 
        }
      ] : null;

      // Lógica para Estacionamento (Manual vs Automático)
      const estacionamentoRow = (estande?.estacionamento != null || estande?.estacionamento_manual) ? [
        { content: `Estacionamento${estande.estacionamento_manual ? ' (Manual)' : ''}` },
        estande.estacionamento_manual 
          ? (estande.estacionamento_valor_salvo <= 0 ? formatCurrency(0) : formatCurrency(estande.estacionamento_valor_salvo / (estande.estacionamento_quantidade_salva || 1)))
          : formatCurrency(estande.estacionamento?.valor / estande.estacionamento?.quantidade),
        estande.estacionamento_manual 
          ? (estande.estacionamento_quantidade_salva || 1)
          : estande.estacionamento?.quantidade,
        { 
          content: estande.estacionamento_manual 
            ? formatCurrency(estande.estacionamento_valor_salvo)
            : formatCurrency(estande.estacionamento?.valor),
          styles: { fontStyle: 'bold' } 
        }
      ] : null;

    autoTable(doc, {
      startY: yPosition,
      head: [['Item', 'Unitário', 'Qtd', 'Total']],
      body: [
        // Linha principal do Espaço
        [
          { content: `${estande.nome} - ${estande.largura}m x ${estande.comprimento}m`, styles: { fontStyle: 'bold' } },
          formatCurrency(estande.valor),
          `${estande.area} m²`,
          { content: formatCurrency(estande.valor_total), styles: { fontStyle: 'bold' } }
        ],
        ...tagsRows,
        ...(kvaRow ? [kvaRow] : []),
        ...(estacionamentoRow ? [estacionamentoRow] : [])
      ],
        margin: { left: margin, right: margin },
        headStyles: {
          fillColor: primaryColor,
          textColor: 255,
          fontSize: 9,
          cellPadding: 2
        },
        bodyStyles: {
          fontSize: 8,
          cellPadding: 2,
          lineWidth: 0.1
        },
        columnStyles: {
          0: { cellWidth: 'auto', fontStyle: 'bold' },
          1: { halign: 'right', cellWidth: 30 },
          2: { halign: 'right', cellWidth: 25 },
          3: { halign: 'right', cellWidth: 30, fontStyle: 'bold' }
        },
        styles: {
          overflow: 'linebreak',
          lineColor: [200, 200, 200],
          lineWidth: 0.1
        },
        didDrawPage: (data) => {
          yPosition = data.cursor.y + 3;
        }
      });

      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(...primaryColor);
      doc.text('TOTAL GERAL:', margin + 100, yPosition);
      doc.text(formatCurrency(estande.valor_total_geral), pageWidth - margin, yPosition, { align: 'right' });
      yPosition += 8;

      // --- IMAGENS ---
      if (estande.imagens?.length > 0) {
          setHeaderStyle();
          doc.text('IMAGENS DO ESPAÇO', margin, yPosition);
          yPosition += 5;

          const imgWidth = (availableWidth / 2) - 5;
          const maxImgHeight = 40; // Altura máxima por imagem
          let currentX = margin;
          let rowHeight = 0;

              
          let maxRowHeight = 0;

          for (let i = 0; i < estande.imagens.length; i++) {
            try {
              const img = new Image();
              img.crossOrigin = 'Anonymous'; // Adiciona cabeçalho CORS
              img.src = estande.imagens[i].url + '?t=' + Date.now(); // Cache busting
              
              await new Promise((resolve, reject) => {
                  img.onload = resolve;
                  img.onerror = reject;
                  setTimeout(() => reject(new Error('Timeout')), 5000);
              });

              const ratio = img.height / img.width;
              const imgHeight = imgWidth * ratio;

              // Lógica de posicionamento (2 por linha)
              if (i > 0 && i % 2 === 0) {
                  yPosition += maxRowHeight + 5;
                  currentX = margin;
                  maxRowHeight = 0;
              }

              doc.addImage(img, 'JPEG', currentX, yPosition, imgWidth, imgHeight);
                  
                  // Adicionar legenda
                  doc.setFontSize(8);
                  doc.text(`Imagem ${i + 1}`, currentX + 2, yPosition + imgHeight + 3);
                  
                  currentX += imgWidth + 5;
                  maxRowHeight = Math.max(maxRowHeight, imgHeight);
              } catch (error) {
                console.error('Erro ao carregar imagem:', error);
                // Adiciona placeholder para imagem não carregada
                doc.setDrawColor(200);
                doc.rect(currentX, yPosition, imgWidth, imgWidth * 0.75);
                doc.text(`Imagem ${i+1} não carregada`, currentX + 5, yPosition + 15);
                
                if (i > 0 && i % 2 === 0) {
                    yPosition += imgWidth * 0.75 + 5;
                    currentX = margin;
                    maxRowHeight = 0;
                } else {
                    currentX += imgWidth + 5;
                    maxRowHeight = Math.max(maxRowHeight, imgWidth * 0.75);
                }
              }
            }
          
      }

      // Rodapé
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(`Gerado em ${moment().format('DD/MM/YYYY HH:mm')}`, margin, 285, { align: 'left' });

      // Logo no centro - do diretório assets
      try {
          // Dimensões da logo (ajuste conforme necessário)
          const logoWidth = 20;
          const logoHeight = 8;
          const logoX = (pageWidth - logoWidth) / 2;
          
          // Adiciona a logo
          const img = new Image();
          img.src = logo;
          
          await new Promise((resolve) => {
          img.onload = () => {
              doc.addImage(img, 'PNG', logoX, 280, logoWidth, logoHeight);
              resolve();
          };
          img.onerror = () => resolve();
          });
      } catch (e) {
          console.log('Erro ao carregar logo:', e);
          doc.setFontSize(10);
          doc.text('', pageWidth / 2, 284, { align: 'center' });
      }
     
      doc.text(`Página ${doc.internal.getNumberOfPages()}`, pageWidth - margin, 285, { align: 'right' });

      // Salvar PDF
      doc.save(`Espaco_${estande.nome}_${moment().format('YYYYMMDD_HHmm')}.pdf`);
      toast.success('PDF exportado com sucesso!');
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error('Erro ao gerar PDF:', error);
      toast.error('Falha ao exportar PDF');
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  return (
    <div>
      <ToastContainer closeButton={false} />
      <div ref={componentRef}>
        <Card>
          <CardHeader>
            <div className="d-flex align-items-center">
              
              <div className="flex-shrink-0">
                <Button 
                  color="primary" 
                  onClick={handleExportPDF}
                  className="me-2"
                  disabled={isLoading}
                >
                  
                    {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      {" Gerando PDF..."}
                    </>
                  ) : (
                    <>
                      <i className="ri-file-pdf-line align-bottom me-1"></i> {"Exportar PDF"}
                    </>
                  )}
                </Button>

              </div>
            </div>
          </CardHeader>
          
          <CardBody>
            {/* Seção de Informações Básicas */}
            <Row className="mb-4">
              <Col md={8}>
                <h5 className="mb-3">
                  <i className="ri-information-line align-bottom me-2"></i> 
                  Informações do Espaço
                </h5>
              
                <Table className="table-sm table-borderless">
                  <tbody>
                    <tr>
                      <th scope="row" style={{width: '140px'}}>Nome:</th>
                      <td>{estande.nome}</td>
                    </tr>
                    <tr>
                      <th scope="row">Área:</th>
                      <td>{estande.area} m²</td>
                    </tr>
                    { 
                      !estande.alterou_area && (
                        <tr>
                          <th scope="row">Dimensões:</th>
                          <td>
                          {estande.largura}m x {estande.comprimento}m
                          {estande.altura_minima && estande.altura_maxima && (
                              <span> (Altura: {estande.altura_minima}m - {estande.altura_maxima}m)</span>
                          )}
                          </td>
                          </tr>
                      )}
                    <tr>
                      <th scope="row">Altura mínima:</th>
                      <td>{estande.altura_minima || 'N/A'} metros</td>
                    </tr>
                    <tr>
                      <th scope="row">Altura máxima:</th>
                      <td>{estande.altura_maxima || 'N/A'} metros</td>
                    </tr>
                    { estande.observacao && (
                      <tr>
                          <th scope="row">Observação:</th>
                          <td>{estande.observacao}</td>
                      </tr>
                    )}
                    <tr>
                      <th scope="row">Pavilhão:</th>
                      <td>{estande.pavilhao != null ? estande.pavilhao.nome : 'Não informado'}</td>
                    </tr>
                    <tr>
                      <th scope="row">M² bonificada:</th>
                      <td>{estande.metragem_bonificada || ''}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col md={4}>
                <h5 className="mb-3">
                  <i className="ri-list-check align-bottom me-2"></i> 
                  Itens Inclusos
                </h5>
                
                {estande.tags && estande.tags.length > 0 && (
                  <div className="d-flex flex-wrap gap-2">
                    {estande.tags.map(tag => (
                      <Badge key={tag.id} color="success" className="fs-12">
                        <i className="ri-checkbox-circle-line align-bottom me-1"></i>
                        {tag.nome}
                      </Badge>
                    ))}
                  </div>
                )}
            
              </Col>
              
            </Row>
            
              {/* Seção de Detalhes Financeiros */}
            <Row>
              <Col>
                <h5 className="mb-3">
                  <i className="ri-money-dollar-circle-line align-bottom me-2"></i> 
                  Detalhes Financeiros
                </h5>
                
                <div className="table-responsive">
                  <Table bordered>
                    <thead className="table-light">
                      <tr>
                        <th>Item</th>
                        <th className="text-end">Valor Unitário</th>
                        <th className="text-end">Quantidade</th>
                        <th className="text-end">Valor Total</th>
                      </tr>
                    </thead>
                    <tbody>
                    
                
                    <tr>
                        
                        <td>
                          <span className="fw-medium">
                            {estande?.nome || 'Espaço'} - 
                            {estande?.largura || '0'}m x {estande?.comprimento || '0'}m
                          </span>
                          <p className="text-muted mb-0">Espaço solicitado</p>
                        </td>
                        <td className="text-end">R$ {(estande?.valor || 0).toFixed(2)}</td>
                        <td className="text-end">{(estande?.area || 0)} m²</td>
                        <td className="text-end">R$ {(estande?.valor_total || 0).toFixed(2)}</td>
                      </tr>
                      {/* Tags/Adicionais */}

                      {estande.tags?.map((tagEstande, index) => {
                        const isManual = tagEstande.manual || tagEstande.manual;
                        const valorUnitario = isManual ? tagEstande.valor_salvo : (tags?.find(t => t.tag_id === tagEstande.id)?.valor || 0);
                        const quantidade = tagEstande.manual && tagEstande.quantidade_salva > 0 ? tagEstande.quantidade_salva :
                          (tagEstande.tag[0].cobra_por_metro ? estande.area : 1);
                        const valorTotalTag = isManual ?
                          (tagEstande.quantidade_salva > 0 ? (tagEstande.valor_salvo * tagEstande.quantidade_salva) :   (tagEstande.valor_salvo * (tagEstande.tag[0].cobra_por_metro ? estande.area : 1))) : 
                          (valorUnitario * (tagEstande.tag[0].cobra_por_metro ? estande.area : 1));

                        return (
                          <tr key={`tag-${tagEstande.id}`}>
                            <td>
                              <span className="fw-medium">
                                {tagEstande.nome} {isManual && <Badge color="info" className="ms-1">Manual</Badge>}
                              </span>
                              <p className="text-muted mb-0">Item adicional</p>
                            </td>
                            <td className="text-end">{formatCurrency(valorUnitario)}</td>
                            <td className="text-end">{tagEstande.manual && tagEstande.quantidade_salva > 0 ? quantidade :
                                    tagEstande.tag[0].cobra_por_metro ? `${estande.area} m²` : quantidade}</td>
                            <td className="text-end">
                              {formatCurrency(valorTotalTag)}
                            </td>
                          </tr>
                        );
                      })}
                    
                      {(estande?.kva != null || estande?.kva_manual) && (
                        <tr style={{ borderBottom: "1px solid #ddd" }}>
                          <td>
                            <span className="fw-medium">
                              KVA {estande.kva_manual && <Badge color="info" className="ms-1">Manual</Badge>}
                            </span>
                            <p className="text-muted mb-0">Item adicional</p>
                          </td>
                          <td style={{ padding: "0.5rem" , textAlign: "right"}}>
                            {estande.kva_manual 
                              ? formatCurrency(estande.kva_valor_salvo / (estande.kva_quantidade_salva || 1))
                              : formatCurrency(estande.kva?.valor / (estande.kva?.quantidade || 1))}
                          </td>
                          <td style={{ padding: "0.5rem", textAlign: "right" }}>
                            {estande.kva_manual 
                              ? (estande.kva_quantidade_salva || 1)
                              : (estande.kva?.cobra_por_metro ? estande.area : estande.kva?.quantidade)}
                          </td>
                          <td style={{ padding: "0.5rem", textAlign: "right" }}>
                            {estande.kva_manual 
                              ? formatCurrency(estande.kva_valor_salvo)
                              : formatCurrency(estande.kva?.cobra_por_metro ? (estande.kva?.valor * estande.area) : estande.kva?.valor)}
                          </td>
                        </tr>
                      )}

                      {(estande?.estacionamento != null || estande?.estacionamento_manual) && (
                        <tr style={{ borderBottom: "1px solid #ddd" }}>
                          <td>
                            <span className="fw-medium">
                              Estacionamento {estande.estacionamento_manual && <Badge color="info" className="ms-1">Manual</Badge>}
                            </span>
                            <p className="text-muted mb-0">Item adicional</p>
                          </td>
                          <td className="right" style={{ padding: "0.5rem", textAlign: "right" }}>
                            {estande.estacionamento_manual 
                              ? (estande.estacionamento_valor_salvo <= 0 ? 0 :
                              formatCurrency(estande.estacionamento_valor_salvo / (estande.estacionamento?.quantidade || 1)))
                              : formatCurrency(estande.estacionamento?.valor / estande.estacionamento?.quantidade)}
                          </td>
                          <td className="right" style={{ padding: "0.5rem", textAlign: "right" }}>
                            {estande.estacionamento_manual 
                              ? (estande.estacionamento_quantidade_salva || 1)
                              : estande.estacionamento?.quantidade}
                          </td>
                          <td style={{ padding: "0.5rem", textAlign: "right" }}>
                            {estande.estacionamento_manual 
                              ? formatCurrency(estande.estacionamento_valor_salvo)
                              : formatCurrency(estande.estacionamento?.valor)}
                          </td>
                        </tr>
                      )}

                    </tbody>
                    <tfoot className="table-light">
                      <tr>
                        <td colSpan="3" className="border-0 fw-bold">Total Geral</td>
                        <td className="border-0 text-end fw-bold">
                          {formatCurrency(estande.valor_total_geral)}
                        </td>
                      </tr>
                    </tfoot>
                  </Table>
                </div>
              </Col>
            </Row>


            {/* Seção de Imagens */}
            {estande.imagens && estande.imagens.length > 0 && (
              <Row className="mb-4">
                <Col>
                  <h5 className="mb-3">
                    <i className="ri-image-line align-bottom me-2"></i> 
                    Imagens
                  </h5>
                  
                  <Row className="g-2">
                    {estande.imagens.map(imagem => (
                      <Col key={imagem.id} sm={6} md={4} lg={3}>
                        <div className="border rounded p-1">
                          <img 
                            src={imagem.url} 
                            alt={`Espaço ${estande.nome}`} 
                            className="img-fluid rounded" 
                          />
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            )}
            
          
            
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default EstandeDetail;